import React from 'react';
import { useTranslation } from 'react-i18next';
import { Transaction } from '../types/budget';
import { formatCurrency } from '../utils/budgetCalculations';

interface TransactionTableFooterProps {
  transactions: Transaction[];
}

export const TransactionTableFooter: React.FC<TransactionTableFooterProps> = ({ transactions }) => {
  const { t } = useTranslation();
  const total = transactions.reduce((acc, t) => acc + t.amount, 0);

  return (
    <tfoot className="bg-gray-50 dark:bg-gray-800">
      <tr>
        <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-300" colSpan={4}>
          {t('transaction.total')}
        </td>
        <td
          className={`whitespace-nowrap px-6 py-4 text-right text-sm font-bold ${
            total >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'
          }`}
        >
          {formatCurrency(total)}
        </td>
        <td></td>
      </tr>
    </tfoot>
  );
};
